import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  combineStates,
  nodeState,
  repositoryState,
  detailedSearchState,
  combineDispatchers,
  detailedSearchDispatcher,
  popupDispatcher,
  productsDispatcher,
  searchState,
  viewSettingsState,
  currentPageState,
  currentPageDispatcher,
  showFooterDispatcher
} from '../../../store';
import { ActionPanel, BusyContainer, CustomContent, ProductCode, ProductDescription, ProductImage, ProductPrice, ProductStock, ProductsViewer, SvgImage } from '../../../components';
import { PropTypes } from 'prop-types';
import { flattenTree, getAccessories, getProductLink } from '../../../util';
import { Box, Button, Grid, IconButton as MuiIconButton, MenuItem, Select, TablePagination, Drawer, Divider } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import productsData from '../../../../app/components/productData.json'
import { FirstPage, LastPage, NavigateBefore, NavigateNext } from '@mui/icons-material';
import { NoResultsFound } from './productViewer';
import { EmptySearchStateIcon, OpenInNewWindow, arrowRightIcon, closePopup } from '../../../../style/images';
import { translate } from '../../../services';
import Pagination from '../../../components/Pagination';
import { ProductItemDetail } from '../../../components/ProductItemDetail';
import classNames from 'classnames';

export class DetailedSearchComponent extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      isSearching: true, 
      stockFilterSelected: false, 
      currentShow:"Products", 
      page:0, 
      rowsPerPage:10,
      currentProducts:[],
      searchKey:"",
      showItemDetails:false,
      expandedItemKeys:[],
      currentItem:{}
    };
    this.setProductsPerPage = this.setProductsPerPage.bind(this);           
    }

  getChildContext() {
    return { getGoToConfig: item => this.getGoToProps( item ) };
  }

  componentDidMount(){
    document.getElementById("search").blur();
  }

  componentWillMount() {
    // Loads some results on initial load
    this.loadDefaultPage( this.props.match.params.query );
  }

  loadDefaultPage( queryString ) {
    let { pageSize, pageResult } = this.props;
    pageSize = 10;
    let queryStringResult = queryString.replace(/^\s+|\s+$/gm,'')
    this.props.searchProducts( queryStringResult, null, pageSize, this.state.stockFilterSelected ).then( () => this.setState( { isSearching: false } ) );
  }

  componentWillReceiveProps( nextProps ) {
    if ( nextProps.match.params.query !== this.props.match.params.query ) {
      this.setState( { isSearching: true }, () => {
        this.query = nextProps.match.params.query;
        this.loadDefaultPage( nextProps.match.params.query );
      } );
    };
  }

  onScrollHandler = e => {
    if ( this.state.isSearching ) return;
    const { pageSize, pageResult } = this.props;
    const { clientHeight, scrollTop, scrollHeight } = e.target;
    if ( scrollTop > ( scrollHeight - clientHeight ) * 0.75 && pageResult.page + 1 < pageResult.totalPages ) {
      this.setState( { isSearching: true, stockFilterSelected: pageResult.request.hasStockFilter ? pageResult.request.hasStockFilter : this.state.stockFilterSelected }, () => {
        pageResult.page += 1;
        this.props.searchProducts( pageResult.request, pageResult, pageSize, this.state.stockFilterSelected ).then( () => this.setState( { isSearching: false } ) );
      } );
    }
  }

  nextPage = (page, rowsPerPage) =>{
    // if ( this.state.isSearching ) return;
    let { pageSize, pageResult } = this.props;

      this.setState( { stockFilterSelected: pageResult.request.hasStockFilter ? pageResult.request.hasStockFilter : this.state.stockFilterSelected }, () => {
        pageResult.page = page;
        this.props.searchProducts( pageResult.request, pageResult, rowsPerPage, this.state.stockFilterSelected ).then( () => this.setState( { isSearching: false } ) );
      } );
  }
  
  getNodeUuid( node, name, property = 'nodeId' ) {
    if ( !this.nodes ) {
      this.nodes = flattenTree( 'children', 'children', 'children' )( node );
    }
    //first look in the tree 
    let searchNode = this.nodes.firstOrDefault( n => n[property] === name );

    //if not found, look in the complex selectors
    if ( !searchNode ) {
      const { items } = this.props;
      const complexSelector = items.firstOrDefault( item =>
        item.complexSelector && item.complexSelector.configurations.firstOrDefault( conf => conf.name === name ) );
      searchNode = complexSelector && { ...this.nodes.firstOrDefault( n => n[property] === complexSelector.name ), complexSelector: true };
    }
    return searchNode;
  }

  getGoToProps( item ) {
    const { node, items: selectorsAll } = this.props;
    const selectorName = item.properties.firstOrDefault( property => property?.name.toLowerCase() === 'selectorname' );
    if ( !selectorName ) {
      return { hidden: true };
    }
    const selector = selectorsAll.firstOrDefault( selector => selector.name.toLowerCase() === selectorName.value.toLowerCase() );
    const searchNode = selector && this.getNodeUuid( node, selector.name, 'selectorName' );
    if ( !searchNode ) {
      return { hidden: true };
    }
    return { assignments: item.assignments, selector, searchNode, hidden: false, onClick: () => this.setState( { active: false } ), materialNameLso: item.materialNameLso };
  }

  onShowChange = (event)=>{
    this.setState({currentShow:event.target.value});
  }

  setProductsPerPage(products){
    this.setState({currentProducts:products})
  }

  checkForDisabled = (param) => {
    const { pageResult } = this.props;
    let { results } = pageResult;
    let productsData = results?results:productsData;
    let startIndex = (this.state.page)*this.state.rowsPerPage;
    let lastIndex = startIndex+this.state.rowsPerPage;
    if(param==="start"){
      return startIndex===0;
    }
    return lastIndex===productsData.length-1
  }

  isExpandable = item => {
    if ( item?.bomItems?.length ) {
      return true;
    } 
    return false;
  }

  setCurrentItem = (item)=>{
    this.setState({currentItem:item})
  }

  toogleItemDetails = (item)=>{
    if(!this.state.showItemDetails){
      this.setCurrentItem(item)
    }
    else{
      this.setCurrentItem({})
    }
    this.setState({showItemDetails:!this.state.showItemDetails})
  }

  renderContent( layout, item, key ) {
    return <CustomContent key={ key } layout={ layout } data={ item } view={this.props.view} />;
  }

  renderColumn( layout, item, key, count ) {

    let content = layout.rows
      ? layout.rows.map( ( row, key ) => this.renderRow( row, item, key, count ) )
      : this.renderContent( layout, item, key );
    
    const className = `col-${key}`;
    return <div className={className} key={key}>{ content }</div>
  }

  renderRow = (layout, item, key, count)=>{
    const content = layout.columns
      ? layout.columns.map( ( col, key) => this.renderColumn( col, item, key, count+1 ) )
      : this.renderContent( layout, item, key );
    
      const className = `count-${count}`
    return <div key={key} className={className}>{ content }</div>
  }

  toggleExpand = (key)=>{
    if(!this.state.expandedItemKeys.includes(key)){
      let arr = this.state.expandedItemKeys;
      arr.push(key);
      this.setState({expandedItemKeys:arr})
    }
    else{
      let arr = this.state.expandedItemKeys;
      let index = arr.indexOf(key);
      if (index > -1) {
        arr.splice(index, 1);
      }
      this.setState({expandedItemKeys:arr})
    }
  }

  getItems=(item)=>{
    const { bomItems, amount } = item;
    if( bomItems?.length ){
      return bomItems.map(b => ({
        name: b.value.name, 
        code: b.value.name, 
        amount: amount,
        description: b.value.value
      }));
    }
    return [];
  }
getAccessoriesLength=(item)=>{
    const accessories=getAccessories(item)
    return accessories? accessories.length:0
  }
  render() {
    if(this.props.currentPage.currentPage!=="detailedSearchPage"){
      this.props.setPage("detailedSearchPage")
    }
    this.props.showFooter();
    // const productData = productsData
    const { pageResult } = this.props;
    let { results } = pageResult;
    let {totalItems} = pageResult;
    let view = "searchproductunavailable";
    if( results && results.length > 0 ){
      const products = results.filter( product => !product.obsolete);
      if( products && products.length > 0 ){
        results = products;
        view = "searchproductdetail"
      }
    }
    // results = results?results:productData
    view = "searchproductdetail"

    let productsData = results;
    let startIndex = (this.state.page)*this.state.rowsPerPage;
    let lastIndex = startIndex+this.state.rowsPerPage;
    let productData = productsData
    lastIndex = lastIndex>productData.length?productData.length:lastIndex;

    let showAvailability = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Availability").length === 1
    let showPriceColumn = this.props.viewSettings["product"]["desktop"]["simple"]?.rows[0].columns.filter(c=>c.title==="Price" || c.title==="PURCHASEPRICE").length === 1
    // const totalItems = pageResult.totalItems <=20 ? results.length : pageResult.totalItems;

    // return <div>
    //   <Fragment>
    //     { this.state.isSearching &&
    //       <BusyContainer isBusy={ true } />
    //     }</Fragment>
    //   <Fragment><ProductsViewer
    //     products={ results }
    //     totalItems={ totalItems }
    //     view= { view }
    //     onScroll={ this.onScrollHandler }
    //     isSearchPage={ true }
    //     hasStockFilter={this.state.stockFilterSelected}
    //   />
    //   </Fragment>
    // </div>;
    return <BusyContainer actions={['search-active', 'filter-active']}>
      <Grid item container xl={12} mt={{md:"3px", xs:"0px"}} height="100%" sx={{overflow:totalItems===0?"hidden":"auto"}}>
        <Grid item xl={12} lg={12} md={12} height="108px"
         sx={
          {display:{md:"flex", xs:"none"}, flexDirection:"column", justifyContent:"start", alignItems:"start", padding:"32px 16px", background: "#FFFFFF"}}>
          <Box height="49px" width="100%" sx={{display:"flex", justifyContent:"start", flexDirection:"column", gap:"14px"}}>
          <Box width="48px" sx={{background:"#FF000F"}} height="5px"></Box>
            <span className='search-result-header'>{totalItems.length!==0?`${translate("Search results for")} "${this.props.pageResult.request.query?this.props.pageResult.request.query:""}"`:`${translate("No Items Found")}`}</span>
          </Box>
        </Grid>
        <Box sx={{display: "flex",
                  width: "100%",
                  height: "1px",
                  justifyContent: "center",
                  aligItems: "center",
                  background:"#DBDBDB"}}></Box>
        {totalItems.length===0?<Grid item xl={12} lg={12} md={12} xs={12} height={{md:"calc(100% - 108px)", xs:"100%"}}>
          <NoResultsFound show isSearchPage image={EmptySearchStateIcon}></NoResultsFound>
        </Grid>:
        <>
          <Grid item container xl={12} lg={12} md={12} height="max-content" sx={{display:{md:"flex", xs:"none"},minHeight:"calc(100% - 108px)", background:"#F5F5F5", padding:"20px 16px 49px 16px"}}>
            {/* <Grid item xl={12} lg={12} md={12} height="100%" overflowY="auto"> */}
              <Grid className='detailed-view' item container xl={12} lg={12} md={12} height="100%">
                  <Box width="100%" height="max-content" display="flex" flexDirection="column" alignContent="center">
                    <Box width="100%" height="90%" display="flex" flexDirection="column" alignContent="center" overflowY="auto">
                      <Fragment>
                          <ProductsViewer
                            products={this.state.currentProducts}
                            totalItems={ totalItems }
                            view= { view }
                            onScroll={ this.onScrollHandler }
                            isSearchPage={ true }
                            hasStockFilter={this.state.stockFilterSelected}
                            hideHeader={false}
                            />
                      </Fragment>
                    </Box>
                    {
                      <Pagination {...this.props} pageresult={pageResult} callNextPage={this.nextPage} setProductsPerPage={this.setProductsPerPage}></Pagination>
                    }
                  </Box>
            </Grid>
          {/* </Grid> */}
          </Grid>
          <Grid className='mobile-detailed-search' xs={12} sx={{display:{md:"none", xs:"flex"},flexDirection:"column", height:"100%", overflowY:"hidden"}} >
              <div style={{width:"100%", height:"100%", flexDirection:"column"}}>
              <Box sx={{display:"flex", width:"100%", padding:"10px 16px", alignItems:"center",height:"37px", gap:"113px",border:"1px", background: "var(--primary-color-background-primary-white, #FFF)"}}>
                <div><span className="search-result-font">{translate("Results")}</span>
                <span className='regular-font-black'>{` (${totalItems})`}</span></div>
              </Box>
              <Box sx={{display:"flex", height:"calc(100% - 37px)", width:"100%", flexDirection:"column", gap:"8px", padding:"8px 16px 8px 16px",overflowY:"auto", background:"var(--primary-color-background-tertiary-white, #F5F5F5)"}} onScroll={this.onScrollHandler}>
              <div className='mobile-serch-product-container' style={{padding:"0px"}}>{results.map((item, key)=>{return(
              <div key={key} className='mobile-search-product'>
                <div className='main-item' style={{display:"flex", justifyContent:"center", alignItems:"center", padding:"24px 16px"}}>
                <div className='item-container'>
                <div style={{height:"max-content", width:"40%", display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                  {
                    this.isExpandable( item ) &&<Box sx={{display:"flex", flexDirection:"column", justifyCounter:"center", alignItems:"center"}}>
                    <div className='accessory-count-badge'>
                      <span>
                        {Object.values( this.getItems(item) )?.length}
                      </span>
                    </div>
                     <div key={ `${ key }_expander` } className={classNames("expandable-indicator icon-button",{"expanded":this.state.expandedItemKeys.includes(key)})}>
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } onClick={()=>this.toggleExpand(key)} />
                    </div></Box>
                    } 
                    {
                    !this.isExpandable( item ) && <div key={ `${ key }_expander` } className="non-expandable-indicator">
                    <SvgImage source={ arrowRightIcon } toolTip={ translate( 'Show Configuration' ) } />
                    </div>
                  }
                   <ProductImage product={ item } alt={ item.productCode } onClick={this.toogleItemDetails} currentItem={item} mobileProductView={true} className="image-container" />
                </div> 
                  <div className='item-section'>
                    <div className='item-details'>
                    <ProductCode { ...item } accessorylength= {this.getAccessoriesLength(item)}  />
                    <ProductDescription product={ item } ></ProductDescription>
                    <ProductDescription product={ item } shortdescriptioncn></ProductDescription>
                    {showAvailability && <ProductStock product={item}></ProductStock>}
                      </div>
                   
                        {showPriceColumn&&<div className='item-price'>
                        <ProductPrice product={item}></ProductPrice>
                      </div>}
                    <div className='item-action'>
                    <ActionPanel showQuantityView={false} mobileSearchView configure quantity add fromSearch product={ item } />
                    </div>
                  </div>
                </div></div>
                {this.state.expandedItemKeys.includes(key)&&<ProductItemDetail showPriceColumn={showPriceColumn} showAvailability={showAvailability} key={key} {...item}></ProductItemDetail>}
              </div>)})}
              </div>
              </Box>
              </div>

              <Drawer anchor='bottom' open={this.state.showItemDetails} onClose={this.toogleItemDetails}
                PaperProps={{
                  sx: {
                    boxShadow:"none",
                    borderRadius: "12px 12px 0px 0px",
                    background: "var(--brand-primary-white, #FFF)"
                  }
                }}>
                  <div className='mobile-item-details'>
                    <div className='close-icon'>
                      <Box component="img" sx={{width:"18px", height:"18px"}} src={closePopup} onClick={this.toogleItemDetails}></Box>
                    </div>
                    <div className='header-frame'>
                      <span className='header'>{translate("Item Details")}</span>
                      <div className='product-details'>
                        <ProductCode { ...this.state.currentItem } />
                        <ProductDescription product={ this.state.currentItem } ></ProductDescription>
                      </div>
                    </div>
                    {this.props.viewSettings["product"]["desktop"]["detailed"].rows[0].columns
                      .filter(column=>column.rows)
                      .map(column=>column.rows)
                      .map((row)=>{return<>
                        <Box sx={{height:"1px", width:"100%", background: "var(--primary-color-grey-10, #EBEBEB)"}}></Box>
                        <div className='extra-details'>{row.map((row, key)=>this.renderRow(row, this.state.currentItem, key, 0))}</div>
                      </>})}
                    <div className='link-container'>
                      <a href={ getProductLink( this.state.currentItem.name ) } target="_blank">
                        <div className='link-box'>
                          <Box sx={{width:"16px", height:"16px"}} component="img" src={OpenInNewWindow}></Box>
                          <span>{translate("Go to product page")}</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </Drawer>
          </Grid>
        </>
        }
    </Grid></BusyContainer>
  }
}

DetailedSearchComponent.propTypes = {
  pageSize: PropTypes.number,
  searchProducts: PropTypes.func.isRequired
};

DetailedSearchComponent.defaultProps = {
  pageSize: 20
};

DetailedSearchComponent.childContextTypes = {
  getGoToConfig: PropTypes.func
};

export const DetailedSearch = connect(
  combineStates( nodeState, detailedSearchState, repositoryState( 'selector' ), searchState,viewSettingsState, currentPageState), 
  combineDispatchers( detailedSearchDispatcher, popupDispatcher, productsDispatcher,showFooterDispatcher, currentPageDispatcher )
)( DetailedSearchComponent );
